module.exports = __webpack_public_path__ + "img/ico-download.96127f2a.svg";